import ecgArchivedIcon from "../../../assets/ecgs/ecg_archived.svg";
import iconRegular from "../../../assets/ecgs/regular_ecg.svg";
import iconHasSymptoms from "../../../assets/ecgs/symptomatic_ecg.svg";
import iconUnreadable from "../../../assets/ecgs/unreadable_ecg.svg";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import styles from "./EcgIcon.module.css";

type EcgIconProps = {
  isEcgArchived?: boolean;
  ecgHasSymptoms?: boolean;
  isEcgUnreadable?: boolean;
};
const EcgIcon = ({
  className,
  isEcgArchived,
  isEcgUnreadable,
  ecgHasSymptoms,
}: PropsWithClassName<EcgIconProps>) => {
  const getEcgIcon = () => {
    // if (isEcgArchived) return ecgArchivedIcon;
    // if (isEcgUnreadable) return iconUnreadable;
    // if (ecgHasSymptoms) return iconHasSymptoms;
    return iconRegular;
  };

  return (
    <BaseIcon icon={getEcgIcon()} className={`${styles.icon} ${className}`} />
  );
};
export default EcgIcon;
